function walletCapablePathname(pathname = window.location.pathname) {
  return /\/customers\/\d+\/?$/.test(pathname) ||
    /\/treatments\/\d+\/?$/.test(pathname) ||
    /\/reservations\/\d+\/?$/.test(pathname) ||
    /\/attendance_portal\/[^/]+\/customers\/\d+\/?$/.test(pathname) ||
    /\/attendance_portal\/[^/]+\/treatments\/\d+\/?$/.test(pathname) ||
    /\/attendance_portal\/[^/]+\/reservations\/\d+\/?$/.test(pathname);
}

export function hasWalletTabContext() {
  return walletCapablePathname();
}

export function walletTabReturnUrl(currentUrl = window.location.href) {
  const url = new URL(currentUrl, window.location.origin);
  const path = url.pathname;

  if (/\/customers\/\d+\/?$/.test(path) || /\/attendance_portal\/[^/]+\/customers\/\d+\/?$/.test(path)) {
    url.searchParams.set('tab', 'info');
    url.searchParams.set('info_tab', 'wallet');
  } else if (walletCapablePathname(path)) {
    url.searchParams.set('res_tab', 'wallet');
  }

  return url.toString();
}

export function reloadWithWalletTabIfNeeded() {
  if (!walletCapablePathname()) return;

  window.location.assign(walletTabReturnUrl());
}
